import React from 'react';
import AppRoutes from './routes';
import { Providers } from './providers';

function App() {
  return (
    <Providers>
      <div className="App">
        <AppRoutes />
      </div>
    </Providers>
  );
}

export default App;
